<div ngbDropdown container="body">
  <button id="oms-order-action-menu"
          (click)="$event.stopPropagation();"
          ngbDropdownToggle>
    <bringoz-icon iconName="menu" class="gray-102"></bringoz-icon>
  </button>
  <div ngbDropdownMenu aria-labelledby="oms-order-action-menu">

    <button
      *ngIf="(order.status !== orderStatuses.OnHold) && (order.status !== orderStatuses.Completed) && (order.status !== orderStatuses.Canceled)"
      ngbDropdownItem
      (click)="onSendToDispatch.emit(order.id); $event.stopPropagation();">
      <div class="layout-row layout-align-start-center">
        <bringoz-icon iconName="calendar-outline" [classSize]="'xl'" class="margin-right-5 gray-102"></bringoz-icon>
        <span translate>Send to Dispatch</span>
      </div>
    </button>

    <button
      ngbDropdownItem
      *ngxPermissionsOnly="'oms.orders.notes'"
      (click)="onAddNote.emit(order.id);$event.stopPropagation();">
      <div class="layout-row layout-align-start-center">
        <bringoz-icon iconName="note" [classSize]="'xl'" class="margin-right-5 gray-102"></bringoz-icon>
        <span translate>AddNote</span>
      </div>
    </button>

    <button
      *ngIf="(order.status !== orderStatuses.OnHold) &&
     (order.status !== orderStatuses.Completed) &&
      (order.status !== orderStatuses.Canceled)"
      ngbDropdownItem
      (click)="onSetOrderOnHold.emit(order.id);$event.stopPropagation();">
      <div class="layout-row layout-align-start-center">
        <bringoz-icon iconName="hold" [classSize]="'xl'" class="margin-right-5 gray-102"></bringoz-icon>
        <span translate>Move to on hold</span>
      </div>
    </button>

    <button
      *ngIf="order.status === orderStatuses.OnHold"
      ngbDropdownItem
      (click)="onResumeOrder.emit(order.id);$event.stopPropagation();">
      <div class="layout-row layout-align-start-center">
        <bringoz-icon iconName="play" [classSize]="'xl'" class="margin-right-5 gray-102"></bringoz-icon>
        <span translate>Resume</span>
      </div>
    </button>

    <button
      *ngIf="order.status === orderStatuses.PendingCompletionApproval"
      ngbDropdownItem
      (click)="onManuallyCompleteOrder.emit(order.id);$event.stopPropagation();">
      <div class="layout-row layout-align-start-center">
        <bringoz-icon iconName="check-circle" [classSize]="'xl'" class="margin-right-5 gray-102"></bringoz-icon>
        <span translate>Manually Complete</span>
      </div>
    </button>

    <ng-container *ngIf="order.status !== orderStatuses.Canceled">
      <button ngbDropdownItem
              *ngxPermissionsOnly="'orders.create'"
              (click)="onEdit.emit(order);$event.stopPropagation();">
        <div class="layout-row layout-align-start-center">
          <bringoz-icon iconName="edit" [classSize]="'xl'" class="margin-right-5 gray-102"></bringoz-icon>
          <span translate>Edit</span>
        </div>
      </button>
    </ng-container>

    <button ngbDropdownItem
            *ngxPermissionsOnly="'orders.create'"
            (click)="onDuplicate.emit(order.id);$event.stopPropagation();">
      <div class="layout-row layout-align-start-center">
        <bringoz-icon iconName="duplicate" [classSize]="'xl'" class="margin-right-5 gray-102"></bringoz-icon>
        <span translate>Duplicate</span>
      </div>
    </button>

    <button
      *ngIf="order.status !== orderStatuses.Canceled && allowPrintingBillOfLading"
      ngbDropdownItem
      (click)="onPrintBillOfLading.emit(order.id);$event.stopPropagation();">
      <div class="layout-row layout-align-start-center">
        <bringoz-icon iconName="print-outline" [classSize]="'xl'" class="margin-right-5 gray-102"></bringoz-icon>
        <span style="text-transform: initial !important;" translate>Print Bill of Lading</span>
      </div>
    </button>

    <button
      *ngIf="order.status !== orderStatuses.Canceled && allowPrintingBillOfLading"
      ngbDropdownItem
      (click)="onDownloadBillOfLading.emit(order.id);$event.stopPropagation();">
      <div class="layout-row layout-align-start-center">
        <bringoz-icon iconName="download" [classSize]="'xl'" class="margin-right-5 gray-102"></bringoz-icon>
        <span style="text-transform: initial !important;" translate>Download Bill of Lading</span>
      </div>
    </button>

    <ng-container *ngIf="order.status !== orderStatuses.Canceled && order.status !== orderStatuses.Completed">
      <button ngbDropdownItem
              *ngxPermissionsOnly="'deliveryscheduling.create'"
              (click)="onSendSchedulingSMSClicked.emit(order);$event.stopPropagation();">
        <div class="layout-row layout-align-start-center">
          <bringoz-icon iconName="sms" [classSize]="'xl'" class="margin-right-5 gray-102"></bringoz-icon>
          <span style="text-transform: initial !important;" translate>Send Scheduling SMS</span>
        </div>
      </button>
    </ng-container>

    <ng-container *ngIf="order.status !== orderStatuses.Canceled && order.status !== orderStatuses.Completed">
      <button ngbDropdownItem
              *ngxPermissionsOnly="'deliveryscheduling.create'"
              (click)="onSendSchedulingWhatsappClicked.emit(order);$event.stopPropagation();">
        <div class="layout-row layout-align-start-center">
          <bringoz-icon iconName="sms" [classSize]="'xl'" class="margin-right-5 gray-102"></bringoz-icon>
          <span style="text-transform: initial !important;" translate>Send Scheduling Whatsapp</span>
        </div>
      </button>
    </ng-container>


    <ng-container *ngIf="(deliverySchedulingStateReference?.status === 'Scheduled'
       || deliverySchedulingStateReference?.status === 'InProgress'
       || deliverySchedulingStateReference?.status === 'ManualHandle') && (order.status !== orderStatuses.Canceled)">
      <button ngbDropdownItem
              *ngxPermissionsOnly="'deliveryscheduling.get'"
              (click)="onViewSchedulingLink.emit(order.id);$event.stopPropagation();">
        <div class="layout-row layout-align-start-center">
          <bringoz-icon iconName="sms" [classSize]="'xl'" class="margin-right-5 gray-102"></bringoz-icon>
          <span style="text-transform: initial !important;" translate>View Scheduling Form</span>
        </div>
      </button>
    </ng-container>

    <button
      *ngIf="order.status !== orderStatuses.Canceled && canRecover"
      ngbDropdownItem
      (click)="onRecover.emit(order.id);$event.stopPropagation();">
      <div class="layout-row layout-align-start-center">
        <bringoz-icon iconName="reoptimize" [classSize]="'xl'" class="margin-right-5 gray-102"></bringoz-icon>
        <span translate>Recover</span>
      </div>
    </button>


    <button *ngIf="order.status !== orderStatuses.Canceled"
            ngbDropdownItem
            (click)="onCancelOrder.emit(order.id);$event.stopPropagation();">
      <div class="layout-row layout-align-start-center">
        <bringoz-icon iconName="close-circle-outline" [classSize]="'xl'" class="margin-right-5 gray-102"></bringoz-icon>
        <span translate>Cancel</span>
      </div>
    </button>

  </div>
</div>
